import { render, staticRenderFns } from "./offershelp.vue?vue&type=template&id=62d70528&"
import script from "./offershelp.vue?vue&type=script&lang=js&"
export * from "./offershelp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('62d70528')) {
      api.createRecord('62d70528', component.options)
    } else {
      api.reload('62d70528', component.options)
    }
    module.hot.accept("./offershelp.vue?vue&type=template&id=62d70528&", function () {
      api.rerender('62d70528', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2F7aqFCH97vr7/JS/offershelp.vue"
export default component.exports